import React from 'react';
import TopBar from "../../components/topbar/Top-Bar";
import SideBar from "../../components/sidebar/sidebar";
import BottomBar from "../../components/bottom_bar";
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UserDashboard from "../../components/Dashboard/UserDashboard"

const HomeDashboard = () => {
	const stat = useSelector(e => e.login);
	const sidebar = useSelector(e => e.sidebarOpen.message);
	// console.log(sidebar)
	// console.log("header", stat.profile_status.profile_status)
	return (
		<div className={`Dashboard bg-[#FAFAFA] grid grid-cols-auto h-full md:grid-cols-smdash grid-rows-sm_dash ${sidebar ? 'lg:grid-cols-dash' : ''} md:grid-rows-dash bg-tet-912 overflow-x-hidden overflow-y-hidden`}>
			<TopBar topBarShowMenu={true} />
			<SideBar />
			<Outlet />
			<BottomBar />
		</div>
	);
};

export default HomeDashboard;
